module.exports = __webpack_public_path__ + "static/media/20200202-sc.09ef6780.jpg";